import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../context/ContextStates';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import { Url } from './Url';
import DetallePedido from './detallePedido';

import { FaPrint } from "react-icons/fa";

const FDelPedido = () => {
    const [observaciones, setObservaciones] = useState('')
    const [rider, setRider] = useState(0)
    const [total, setTotal] = useState(0)
    const [viewCpbt, setViewCpbt] = useState(false)
    const { pedidoSelected, setViewOpen, modify, setModify, idUsuario, roles, setAuxVenta } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        console.log("ver adentro ", pedidoSelected)
        const calcTotal = () => {
            let aux = 0;

            pedidoSelected.productos.forEach(element => {
                let subAux = 0;
                //console.log("producto: ",element)
                if (element.subproductos.length > 0) {
                    element.subproductos.forEach(item => {
                        subAux = subAux + parseFloat(item.precio)
                    })
                }
                aux = aux + (parseFloat(element.monto) + subAux) * parseInt(element.cantidad);
            });
            setTotal(aux)
        }
        calcTotal()
    }, [])

  
    const eliminarPedido = async () => {
        const formData = new FormData()
        formData.append("id", pedidoSelected.id)
        formData.append("idusuario", idUsuario)
        formData.append("estado", 5)
        formData.append("observaciones", observaciones)
        formData.append("rider", rider)
        try {
            const response = await axios({
                url: Url + 'api/setPedidoEstado.php',
                method: 'POST',
                data: formData,
            })
            console.log(response)
            let aux = modify + 1;
            setModify(aux);
            setViewOpen(false)
        } catch (e) {
            console.log(e)
        }
    }

    return (

        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            <div className="w-full mt-5 py-2 px-3 rounded-2xl">
                <div className='print:px-4 print:text-xs print:h-svh' ref={componentRef}>
                    <h2 className='text-center text-gray-700 text-xl mb-5'>Comanda - Pedido Nº {pedidoSelected.numero}</h2>
                    <div className='w-10/12 mx-auto justify-items-center'>
                        <p className='text-center'><span className='font-bold'>Cliente: </span>{pedidoSelected.cliente}</p>
                        <p className='text-center'><span className='font-bold'>Tel: </span>{typeof pedidoSelected.telefono!=='undefined' && pedidoSelected.telefono!=='undefined' && pedidoSelected.telefono}</p>
                        <p className='text-center'><span className='font-bold'>Domicilio: </span>{pedidoSelected.domicilio}</p>
                        <p className='text-center'><span className='font-bold'>Observaciones de Domicilio: </span>{pedidoSelected.obsdom}</p>
                        <p className='text-center mt-4 text-xl'>{pedidoSelected.descripcion}</p>
                        <div className='w-full flex p-3'>
                            <p className='text-center mt-4 text-lg font-semibold'>Pago con {pedidoSelected.mediopago}</p>
                            {!viewCpbt ? (
                                <button
                                    type="button"
                                    className="shadow-md print:invisible p-3 ml-3 bg-green-500 text-white hover:bg-green-400 transition-all uppercase font-bold rounded-lg"
                                    onClick={() => setViewCpbt(true)}
                                >
                                    Ver comprobante
                                </button>
                            ) : (
                                pedidoSelected.ctransf !== '' &&
                                <div className='w-1/2 mx-auto print:invisible'>
                                    <img className='w-1/3 object-cover rounded' src={Url + pedidoSelected.ctransf} />
                                    <button
                                        type="button"
                                        className="shadow-md p-3 ml-3 bg-orange-500 text-white hover:bg-orange-400 transition-all uppercase font-bold rounded-lg"
                                        onClick={() => setViewCpbt(false)}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            )}
                        </div>
                        {pedidoSelected.efectivo !== '0' && (
                            <p className='text-center mt-4 text-xl'>Cambio de $ {pedidoSelected.efectivo}</p>
                        )}
                        {typeof pedidoSelected.productos !== 'undefined' && pedidoSelected.productos.map((item, index) => (
                            <div key={index} className='w-full border border-gray-200 rounded mb-1'>
                                <div className='w-full font-semibold flex mt-2 p-2'>
                                    <div className='w-1/5 print:w-0 print:invisible'>
                                        <img className='w-1/3 object-cover rounded' src={Url + item.imagen} />
                                    </div>
                                    <div className='w-3/5 print:w-4/5 print:pr-10'>
                                        <p className='text-left print:text-xs'>{`${parseInt(item.cantidad)} x ${item.descripcion}`}</p>
                                    </div>
                                    <div className='w-1/5 print:pr-10'>
                                        <p className='text-right print:text-xs'>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                    </div>
                                </div>
                                {typeof item.subproductos !== 'undefined' && item.subproductos.map((item, index) => (
                                    <div key={index}>
                                        <div className='pl-10 mt-0'>
                                            <div className='print:pl-2 print:pr-10'>
                                                <p className='text-left ml-10 print:text-xs'>{item.descripcion}<span className='font-bold'>{item.precio !== '0' && (' - $ ' + item.precio)}</span></p>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className='w-full mt-2 p-2'>
                                    {item.nota !== '' && (
                                        <p><span className='font-semibold'>Nota: </span>{item.nota}</p>
                                    )}
                                </div>
                            </div>
                        ))}
                        <div className='w-full font-semibold flex mt-2 p-2'>
                            <div className='w-full pl-2'>
                                <p className='text-left font-bold uppercase text-3xl print:text-sm'>Total</p>
                            </div>
                            <div className='w-full pr-10'>
                                <p className='text-right font-bold uppercase text-3xl print:text-sm'>${parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                            </div>
                        </div>
                    </div>
                    <input className='w-full p-3 rounded border border-gray-300' placeholder='Observaciones' type='text' value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                </div>
                <div className="w-full rounded-lg mt-10">

                    <div className='w-full flex'>
                        {
                            roles.includes("1") && (
                                <div className='w-1/2'>
                                <button
                                    type="button"
                                    className={`w-full mx-2 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg mt-5 bg-red-500`}
                                    onClick={() => eliminarPedido()}
                                >
                                    Eliminar Pedido
                                </button>
                            </div>
                            )
                        }

                        <div className='w-1/2'>
                            <button
                                type="button"
                                className={`w-full ml-4 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg mt-5 bg-gray-500`}
                                onClick={() => setViewOpen(false)}
                            >
                                Salir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FDelPedido